var exports = {
  "iE": "ScrollFillerSkeleton.module__wrapper___ZVZ0TD",
  "hw": "ScrollFillerSkeleton.module__wrapperCompact___ZVZ0TD",
  "vy": "ScrollFillerSkeleton.module__messageGroup___ZVZ0TD",
  "Os": "ScrollFillerSkeleton.module__group___ZVZ0TD",
  "my": "ScrollFillerSkeleton.module__avatar___ZVZ0TD",
  "rf": "ScrollFillerSkeleton.module__body___ZVZ0TD",
  "wx": "ScrollFillerSkeleton.module__header___ZVZ0TD",
  "el": "ScrollFillerSkeleton.module__cozyLeadLine___ZVZ0TD",
  "B8": "ScrollFillerSkeleton.module__cozyContinuation___ZVZ0TD",
  "Tw": "ScrollFillerSkeleton.module__cozyContinuationLine___ZVZ0TD",
  "Xw": "ScrollFillerSkeleton.module__cozyAttachment___ZVZ0TD",
  "Ov": "ScrollFillerSkeleton.module__compactMessages___ZVZ0TD",
  "ir": "ScrollFillerSkeleton.module__compactRow___ZVZ0TD",
  "ce": "ScrollFillerSkeleton.module__compactTimestamp___ZVZ0TD",
  "Ys": "ScrollFillerSkeleton.module__compactBody___ZVZ0TD",
  "tQ": "ScrollFillerSkeleton.module__compactAuthorPrefix___ZVZ0TD",
  "hn": "ScrollFillerSkeleton.module__compactAvatar___ZVZ0TD",
  "_l": "ScrollFillerSkeleton.module__compactUsername___ZVZ0TD",
  "Mf": "ScrollFillerSkeleton.module__compactLine___ZVZ0TD",
  "Zb": "ScrollFillerSkeleton.module__compactAttachment___ZVZ0TD",
};

module.exports = exports;
